module.exports = __webpack_public_path__ + "static/media/question.c7f22bd2.svg";